import { Component, effect, EventEmitter, inject, Input, model, OnInit, Output } from '@angular/core';
import { entre0Y100 } from '../../../validators/transformations';
import { UsuarioMongo } from '../../../model/usuario';
import { FormBuilder, FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { AbstractComponent } from '../../../abstract-component';

@Component({
  selector: 'app-mongo-detalle-usuario',
  imports: [FormsModule, CommonModule, ReactiveFormsModule],
  templateUrl: './mongo-detalle-usuario.component.html',
  styleUrl: './mongo-detalle-usuario.component.css'
})
export class MongoDetalleUsuarioComponent extends AbstractComponent implements OnInit {
  private formBuilder = inject(FormBuilder);
  // Primero lo hacemos con el deprectado @Input y @Output y luego lo hacemos con el nuevo @Signal
  // Para probar propiedad de componente que admite entrada desde fuera y si el componente lo cambia, emite un evento de salida
  @Input() usuario?: Partial<UsuarioMongo>;
  @Output() cambioEnUsuarios = new EventEmitter();
  usuarioSignal = model<UsuarioMongo>()

  // Ahora con signals
  inputPropertySignal = model(0)

  usuarioForm = this.formBuilder.group({
    id: [""],
    nombre: ['', Validators.required],
    apellidos: ['', Validators.required],
    direccion: ['', Validators.required],
    fxNacimiento: ['', Validators.required],
    fxAlta: ['', Validators.required],
    fxModificacion: ['', Validators.required],
  });
  constructor() {
    super();
    console.log(`MongoDetalleUsuarioComponent.constructor()`);
    effect(() => {
    console.log(`MongoDetalleUsuarioComponent.effect() usuarioSignal: ${this.usuarioSignal()?.nombre}`);
    if (this.usuarioSignal) {
      console.log("Setting usuarioForm values from usuarioSignal");
      this.usuarioForm.patchValue({
        id: this.usuarioSignal()?.id,
        nombre: this.usuarioSignal()?.nombre,
        apellidos: this.usuarioSignal()?.apellidos,
        direccion: this.usuarioSignal()?.direccion,
        fxNacimiento: this.usuarioSignal()?.fxNacimiento?.toString(),
        fxAlta: this.usuarioSignal()?.fxAlta?.toString(),
        fxModificacion: this.usuarioSignal()?.fxModificacion?.toString(), 
      });
    }
  });
  }

  ngOnInit() {
    console.log(`MongoDetalleUsuarioComponent.ngOnInit()`);
    this.usuarioForm.get("id")?.setValue("")
  }

  
  onDelete() {
    console.log("Delete button clicked");
    const usuarioId = this.usuarioForm.get('id')?.value!;
    this.usuarioForm.get("id")?.setValue("")
    this.dhrService.deleteUserMongo(this.usuarioSignal()?.id!).subscribe({
      next: (response) => {
        console.log('User deleted successfully:', response);
        this.cambioEnUsuarios.emit(response);
      },
      error: (error) => {
        console.error('Error deleting user:', error);
      }
    });
  }
  onClean() {
    this.usuarioForm.patchValue({
        id: "",
        nombre: "",
        apellidos: "",
        direccion: "",
        fxNacimiento: "",
        fxAlta: "",
        fxModificacion: ""
      });
  }
  onSubmit(){
    console.log("Form submitted");
    console.log(`First Name: ${this.usuarioForm.get('nombre')?.value}`);
    const usuario: Partial<UsuarioMongo> = {
      nombre: this.usuarioForm.get('nombre')!.value!,
      apellidos: this.usuarioForm.get('apellidos')?.value!,
      direccion: this.usuarioForm.get('direccion')?.value!,
      fxNacimiento: new Date(this.usuarioForm.get('fxNacimiento')?.value!),
      fxAlta: new Date(this.usuarioForm.get('fxAlta')?.value!),
      fxModificacion: new Date(this.usuarioForm.get('fxModificacion')?.value!),
      id: this.usuarioForm.get('id')?.value! as string,
      
    };
    console.log(`Usuario: ${JSON.stringify(usuario)}`);
    this.dhrService.insertOrUpdateUserMongo(usuario).subscribe({
      next: (response: UsuarioMongo) => {
        console.log('Response from DhrService:', response);
        this.cambioEnUsuarios.emit(response);
      },
      error: (error: any) => {
        console.error('Error from DhrService:', error);
      }
    });

    //this.usuarioSignal()?.nombre = this.usuarioForm.get('nombre')?.value;

  }

}
